import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/core-web-vitals-2026")(blogRouteOptions("core-web-vitals-2026"));
